import { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BASE_WS_URL } from '../config/config';

export default function useCasinoBetplace(gameId,socketData,activeRoundId) {
    const [bets, setBets] = useState([]);
    const [globalBets, setGlobalBets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [exposure, setExposure] = useState(0);
    const [currentRoundId, setCurrentRoundId] = useState(null);
    const [exposureData, setExposureData] = useState(null);

    const { userId } = useSelector((state) => state.auth);



    

    const wsRef = useRef(null);
    const isMountedRef = useRef(true);
    const reconnectTimeoutRef = useRef(null);
    const reconnectAttemptsRef = useRef(0);
    const settleTimeoutRef = useRef(null);

    // Round Management Refs
    const prevRoundIdRef = useRef(null);
const activeRoundIdRef = useRef(activeRoundId);

    useEffect(() => {
        activeRoundIdRef.current = activeRoundId;
    }, [activeRoundId]);
    // Result Time se exposure reset
    const resultTime = socketData?.settlement?.resultTime;
    useEffect(() => {
        if (resultTime === 1 || resultTime === 2) {
            setExposureData(null);
        }
    }, [resultTime]);

    const addBet = useCallback((newBet) => {
        setBets(prev => prev.some(b => b.betId === newBet.betId) ? prev : [newBet, ...prev]);
    }, []);

    const addGlobalBet = useCallback((newBet) => {
        setGlobalBets(prev => prev.some(b => b.betId === newBet.betId) ? prev : [newBet, ...prev]);
    }, []);

   
    const handleRoundChange = useCallback((newRoundId) => {
        if (!newRoundId) return;

        const oldRoundId = prevRoundIdRef.current;

        // Agar roundId change hua hai tabhi clear karo
        if (oldRoundId && String(oldRoundId) !== String(newRoundId)) {
            console.log(`🔄 Round Changed: ${oldRoundId} → ${newRoundId} | Clearing old bets`);
            
            setBets(prev => prev.filter(b => String(b.roundId) !== String(oldRoundId)));
            setGlobalBets(prev => prev.filter(b => String(b.roundId) !== String(oldRoundId)));
        } else {
            console.log(`🔄 Same Round: ${newRoundId} - Bets not cleared`);
        }

        prevRoundIdRef.current = newRoundId;
        setCurrentRoundId(newRoundId);
    }, []);


    const connectWebSocket = useCallback(() => {
        if (wsRef.current) wsRef.current.close();

        if (!userId || !gameId) return;

        const ws = new WebSocket(`${BASE_WS_URL}/casino/bets/${userId}/${gameId}`);
        wsRef.current = ws;

        ws.onopen = () => {
            console.log('✅ WS Connected');
            setIsConnected(true);
            setLoading(false);
            setError(null);
            reconnectAttemptsRef.current = 0;
            ws.send(JSON.stringify({ event: "REGISTER_USER", userId }));
        };

        ws.onmessage = (event) => {
            if (!isMountedRef.current) return;
            try {
                const data = JSON.parse(event.data);
                const eventType = data.event || data.type;

                switch (eventType) {

             case "BET_PLACED":
    const betRoundId = data.roundId || 
                      data.bet?.roundId || 
                      activeRoundIdRef.current || 
                      currentRoundId;

    console.log("BET_PLACED received for round:", betRoundId);

    if (data.bet) {
        addBet({ 
            ...data.bet, 
            roundId: betRoundId 
        });
    }

    if (Array.isArray(data.bets)) {
        data.bets.forEach(b => {
            addBet({ 
                ...b, 
                roundId: b.roundId || betRoundId 
            });
        });
    }

    if (betRoundId) {
        handleRoundChange(betRoundId);
    }
    break;

                    case "BET_LIST":
                    case "INITIAL_BETS":
                        if (Array.isArray(data.bets)) {
                            const processed = data.bets.map(b => ({
                                ...b,
                                roundId: b.roundId || data.roundId
                            }));
                            setBets(processed);
                        }
                        if (data.roundId) handleRoundChange(data.roundId);
                        break;

                    case "EXPOSURE_UPDATE":
                        setExposureData(data);
                        if (data.selection === "AVIATOR") {
                            setExposure(data.exposure ?? 0);
                        }
                        if (data.roundId) {
                            handleRoundChange(data.roundId);
                        }
                        break;

                    case "TIMER_UPDATE":
                        if (data.roundId) {
                            handleRoundChange(data.roundId);
                        }
                        break;

                  case "ROUND_SETTLED":
    setBets([]);
    setGlobalBets([]);
    setExposure(0);
    setExposureData(null);

    break;

                    case "GLOBAL_BET_PLACED":
                        const gRoundId = data.roundId;
                        if (gRoundId) addGlobalBet({ ...data, roundId: gRoundId });
                        if (gRoundId) handleRoundChange(gRoundId);
                        break;

                    case "CASHOUT":
                        const cRoundId = data.roundId || currentRoundId;
                        setBets(prev => prev.map(b => b.betId === data.betId ? 
                            { ...b, multiplier: data.cashoutMultiplier, cashout: data.payout, roundId: cRoundId } : b));
                        setGlobalBets(prev => prev.map(b => b.betId === data.betId ? 
                            { ...b, x: data.cashoutMultiplier, cashout: data.payout, roundId: cRoundId } : b));
                        break;

                    default:
                        break;
                }
            } catch (err) {
                console.error("WS Parse Error:", err);
            }
        };

        ws.onerror = () => setError("Connection error");
        ws.onclose = () => {
            setIsConnected(false);
            if (!isMountedRef.current) return;
            reconnectAttemptsRef.current += 1;
            const delay = Math.min(2000 * Math.pow(1.5, reconnectAttemptsRef.current), 10000);
            reconnectTimeoutRef.current = setTimeout(() => {
                if (isMountedRef.current) connectWebSocket();
            }, delay);
        };
    }, [userId, gameId, addBet, addGlobalBet, handleRoundChange]);

    useEffect(() => {
        isMountedRef.current = true;
        connectWebSocket();

        return () => {
            isMountedRef.current = false;
            if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
            if (settleTimeoutRef.current) clearTimeout(settleTimeoutRef.current);
            if (wsRef.current) wsRef.current.close();
        };
    }, [userId, gameId, connectWebSocket]);

    return {
        bets,
        globalBets,
        loading,
        error,
        isConnected,
        exposure,
        currentRoundId,
        exposureData,
    };
}